import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChatIcon, StorefrontIcon } from '@yonderland/andes-icons';
import { Icon, Link } from '@yonderland/andes-react';
const ICONS_MAPPING = {
    stores: StorefrontIcon,
    help: ChatIcon,
    support: ChatIcon,
};
const QuickLinksItem = ({ linkKey, linkName, linkPath }) => {
    return (_jsxs(Link, { testId: linkKey, theme: "neutral", variant: "tertiary", size: "sm", href: linkPath, children: [ICONS_MAPPING[linkKey] && _jsx(Icon, { size: "sm", source: ICONS_MAPPING[linkKey] }), linkName] }));
};
export default QuickLinksItem;
